import InsurancePage from "./insurance/index/InsurancePage.vue";
import FamilyTabbedContent from "./insurance/index/components/FamilyTabbedContent.vue";
import PolicyShowPage from "./insurance/policy_show/PolicyShowPage.vue";
import PolicyCreatePage from "./insurance/policy_create/PolicyCreatePage.vue";
import PolicyEditPage from "./insurance/policy_edit/PolicyEditPage.vue";
import PackageCreateOrEditPage from "./insurance/package_create_or_edit/PackageCreateOrEditPage.vue";
import CreateOrEditTaskPage from "./tasks/task_create/CreateOrEditTaskPage.vue";
import VueCustomerPageRoot from "./VueCustomerPageRoot.vue";
import EmailPage from "./email/Index.vue";
import VueDashboardPageRoot from "./VueDashboardPageRoot.vue";
import CustomerAnalysisPage from "~/pages/analysis/CustomerAnalysisPage.vue";
import TaskListIndex from "./tasks/task_lists/Index.vue";
import TaskListCreate from "./tasks/task_lists/Create.vue";

export default {
  install(Vue) {
    // Register imported components using Vue.component()
    Vue.component("VueDashboardPageRoot", VueDashboardPageRoot);
    Vue.component("VueCustomerPageRoot", VueCustomerPageRoot);
    Vue.component("InsurancePage", InsurancePage);
    Vue.component("PolicyShowPage", PolicyShowPage);
    Vue.component("PolicyCreatePage", PolicyCreatePage);
    Vue.component("PolicyEditPage", PolicyEditPage);
    Vue.component("PackageCreateOrEditPage", PackageCreateOrEditPage);
    Vue.component("FamilyTabbedContent", FamilyTabbedContent);
    Vue.component("CreateOrEditTaskPage", CreateOrEditTaskPage);
    Vue.component("EmailPage", EmailPage);
    Vue.component("CustomerAnalysisPage", CustomerAnalysisPage);
    Vue.component("TaskListIndex", TaskListIndex);
    Vue.component("TaskListCreate", TaskListCreate);
  },
};
